import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './EmailVerifiedSuccess.module.css';
import { useTranslation } from 'react-i18next';

const EmailVerifiedSuccess = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('auth');
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{t('emailVerifiedSuccess.title')}</h2>
      <p className={styles.desc}>{t('emailVerifiedSuccess.desc')}</p>
      <div className={styles.actions}>
        <button type="button" className={styles.primary} onClick={() => navigate('/login')}>
          {t('emailVerifiedSuccess.toLogin')}
        </button>
        <button type="button" className={styles.secondary} onClick={() => navigate('/')}>{t('emailVerifiedSuccess.toTop')}</button>
      </div>
    </div>
  );
};

export default EmailVerifiedSuccess;
